import script from "./ReceiptDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceiptDialog.vue?vue&type=script&setup=true&lang=js"

import "./ReceiptDialog.vue?vue&type=style&index=0&id=3a6245a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a6245a7"]])

export default __exports__